import { Component, Input } from '@angular/core';

import { TimelineItemInterface } from '~/component/timeline/interfaces/item.interface';
import { VtmnPlayIconTypeEnum } from '~/component/vtmn-play-icon/enums/vtmn-play-icon-type.enum';

@Component({
  selector: 'app-timeline-item',
  templateUrl: './item.component.html',
  styleUrls: ['./item.component.scss'],
})
export class TimelineItemComponent {
  @Input() public index: number;
  @Input() public item: TimelineItemInterface;

  public get content(): string {
    return this.item?.content || '';
  }

  public get headerContent(): string {
    return this.item?.iconType ? '' : String((this.index || 0) + 1);
  }

  public get iconType(): VtmnPlayIconTypeEnum | undefined {
    return this.item?.iconType;
  }
}
